define('model/lock.model',['require','exports','module','fukit','fukit','fukit','./person.model'],function(require, exports, module) {
  //prettier-ignore
  var BaseModel               = require('fukit').BaseModel,
      FindFirstQueryModel     = require('fukit').FindFirstQueryModel,
      ResourceQueryCollection = require('fukit').ResourceQueryCollection,
      PersonModel             = require('./person.model');

  var BaseLockModel = BaseModel.extend({
    urlRoot: '/api/v1/eform/lock',
  });

  var LockModel = FindFirstQueryModel.extend({
    queryFirstFetchOnly: false,

    clearOnEmpty: false,

    filterUsingAttributes: ['templateId'],

    collection: ResourceQueryCollection.extend({
      model: BaseLockModel,
      query: {
        select: [{ from: 'Lock.*' }, { from: 'Person.firstName' }, { from: 'Person.lastName' }],
        resourceClass: BaseLockModel.Collection,
        as: 'Lock',
        join: [
          {
            resourceClass: PersonModel.Collection,
            as: 'Person',
            on: {
              userAccountId: 'Lock.createUser',
            },
          },
        ],
      },
    }),
  });

  module.exports = LockModel;
});

